import addProductToCart from './addProductToCartSchema';
import addToCart from './addToCart';
import seatAddToCart from './seatAddToCart';
import piaddToCart from './personalInsuranceaddToCart';
import ancillariesSchema from './ancillariesSchema';
import baggageSchema from './baggageSchema';
import B2BCAnalytics from './B2BCAnalytics';
import paymentInfo from './paymentInfo';
import cobrandAffiliate from './CobrandAffiliateSchema';
import corporatePnrLookup from './corporatePnrLookup';
import corporatePriority from './corporatePriority';
import corporateSeatMap from './corporateSeatMap';
import emdVoucherValidate from './emdValidateSchema';
import fareLockPurchase from './fareLockSchema';
import personalizedAcquisition from './personalizedAcquisitionSchema';
import product from './productSchema';
import productClick from './productClickSchema';
import productImpression from './productImpressionSchema';
import removeProductFromCart from './removeProductFromCartSchema';
import personalizedInsurancesSchema from './personalizedInsuranceSchema';
import seats from './seats';
import viewItem from './viewItemSchema';
import seatViewItemSchema from './seatViewItemSchema';
import userPropertiesWebSchema from './userPropertiesWebSchema';
import journeySuccess from './journeySuccessSchema';
import seatsSchema from './seatsSchema';
import autoAcceptSchema from './autoAcceptSchema';
import stepPaxSchema from './stepPaxSchema';
import selectedCarSchema from './selectedCarSchema';

export default {
  addProductToCart,
  addToCart,
  ancillariesSchema,
  autoAcceptSchema,
  baggageSchema,
  B2BCAnalytics,
  cobrandAffiliate,
  corporatePnrLookup,
  corporatePriority,
  corporateSeatMap,
  emdVoucherValidate,
  fareLockPurchase,
  journeySuccess,
  paymentInfo,
  personalizedAcquisition,
  personalizedInsurancesSchema,
  piaddToCart,
  product,
  productClick,
  productImpression,
  removeProductFromCart,
  seats,
  seatViewItemSchema,
  stepPaxSchema,
  viewItem,
  seatAddToCart,
  seatsSchema,
  selectedCarSchema,
  userPropertiesWebSchema,
};
